// KL-27: inspection kind
export enum InspectionKind {
	Scheduled = 1,
	Unscheduled = 2,
}
